import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const CantidadUsuariosFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='CANTIDAD USUARIOS' htmlFor='input-cantidadUsuarios' md={12} />
      <Col md={12}>
        <Field name='cantidadUsuarios'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              id='input-cantidadUsuarios'
              disabled={fIsSubmitting}
              isInvalid={iTouched && iError}
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CantidadUsuariosFormGroup)
